import { TabPill } from 'types/tabs';

/* eslint-disable import/prefer-default-export */
export enum LeadDetailTabId {
  ACTIVITIES = 'activities',
  NOTES = 'notes',
  TIMELINE = 'timeline',
  ATTACHMENTS = 'attachments',
  FORM_RESPONSE = 'form-response'
}

export const mainTabs: TabPill[] = [
  { id: LeadDetailTabId.ACTIVITIES, label: 'Activities' },
  { id: LeadDetailTabId.NOTES, label: 'Notes' },
  { id: LeadDetailTabId.TIMELINE, label: 'Timeline' },
  { id: LeadDetailTabId.ATTACHMENTS, label: 'Attachment' },
  { id: LeadDetailTabId.FORM_RESPONSE, label: 'Form Fields' }
];

export const paymentTableColumn = [
  { Header: 'Branch', accessor: 'branch', width: '11%' },
  { Header: 'Group/Notes', accessor: 'groupNotes', width: '11%' },
  { Header: 'Requested on', accessor: 'requestedOn', width: '11%' },
  { Header: 'Paid On', accessor: 'paidOn', width: '10%' },
  { Header: 'Settled On', accessor: 'settledOn', width: '10%' },
  { Header: 'Amount', accessor: 'amount', width: '15%' },
  { Header: 'Actions', accessor: 'actions', width: '8%' }
];

export const addToBranchGroupTableColumn = [
  { Header: 'Branch', accessor: 'branch', width: '13%' },
  { Header: 'Group', accessor: 'groupName', width: '13%' },
  { Header: 'Amount', accessor: 'amount', width: '10%' },
  { Header: 'Recurs', accessor: 'recurs', width: '13%' },
  {
    Header: 'Next request date',
    accessor: 'nextRequestDate',
    width: '13%'
  },
  { Header: 'Actions', accessor: 'actions', width: '8%' }
];

export const paymentCollectionTableColumn = [
  { Header: 'Branch', accessor: 'branch', width: '13%' },
  { Header: 'Group', accessor: 'groupName', width: '10%' },
  { Header: 'Group Amount', accessor: 'groupAmount', width: '16%' },
  {
    Header: 'Fee collection date',
    accessor: 'feeCollectionDate',
    width: '10%'
  },
  { Header: 'Start date', accessor: 'startDate', width: '10%' },
  { Header: 'Actions', accessor: 'actions', width: '8%' }
];
